<template>
    <div>
        <span>{{ $_.get(activity, 'actorUser.name') || 'Bilinmeyen Kullanıcı' }} kullanıcısı "{{ $_.get(activity, 'payload.taskTitle') || 'Bilinmeyen Görev' }}" adlı görevi arşivden geri çıkardı.</span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskUnarchived",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>
<style scoped lang="scss"></style>

